import { useContext, useEffect, useState } from "react"
import { useNodesState, useEdgesState, addEdge } from "@xyflow/react"

import { randomColor } from "../util/util"
import { useDispatch, Actions, useSelector } from "../stores/dashboard.store"
import { darkenRGBString, brightenRGBString } from '../util/util'
import NodeValueContext from "../context/node-value.context"

export default () => {
    const { setSelectedNode } = useContext(NodeValueContext)
    const dispatch = useDispatch()

    const colors = useSelector(x => x?.colors)

    const [nodes, setNodes, onNodesChange] = useNodesState([])
    const [edges, setEdges, onEdgesChange] = useEdgesState([])

    const [activeEdgeId, setActiveEdgeId] = useState()
    const [activeNode, setActiveNode] = useState({
        editMode: false,
        id: undefined,
    })

    const setActiveNodeIdFL = (id, editMode = false) => {
        setSelectedNode(id, editMode)
        setActiveNode({
            id, editMode
        })
    }

    const onConnect = (params) => {
        if (params.source === params.target) return
        const taredge = edges.find(
            (edge) =>
                edge.target === params.target &&
                edge.targetHandle === params.targetHandle
        )


        const srcNode = nodes.find((node) => node.id === params.source).data

        const tarNodeType = nodes.find((node) => node.id === params.target).data.inputs.find((inputs) => inputs.id === params.targetHandle).type
        const srcNodeType = srcNode.outputs.find((output) => output.id === params.sourceHandle).type

        if (taredge === undefined && (tarNodeType === srcNodeType || (tarNodeType === "any"))) {
            const color = colors[srcNodeType] || randomColor()

            setEdges((eds) =>
                addEdge(
                    {
                        ...params,
                        style: {
                            stroke: `rgb(${color[0]}, ${color[1]}, ${color[2]})`,
                            strokeWidth: 2,
                        },
                        type: "smoothstep",
                    },
                    eds
                )
            )
        }
    }

    const onEdgeClick = (event, edge) => {
        setEdges((eds) =>
            eds.map((e) => {
                if (e.id === edge?.id) {
                    if (e?.id === activeEdgeId) {
                        return { ...e, style: { ...e.style } }
                    }
                    const color = darkenRGBString(e?.style?.stroke, 50)
                    return { ...e, style: { ...e.style, stroke: `rgb(${color[0]}, ${color[1]}, ${color[2]})` } }
                }
                if (e?.id === activeEdgeId) {
                    // set the old activeEdgeId back
                    const color = brightenRGBString(e?.style?.stroke, 50)
                    return { ...e, style: { ...e.style, stroke: `rgb(${color[0]}, ${color[1]}, ${color[2]})` } }
                }

                return e
            })
        )
        setActiveNodeIdFL(undefined)
        setActiveEdgeId(edge?.id)
    }

    const onPaneClick = () => {
        onEdgeClick(undefined, { id: undefined })
        setActiveNodeIdFL(undefined)
        setActiveEdgeId(undefined)
    }

    const deleteActiveNodeAndEdge = () => {
        // cleanup the active edge
        setEdges((eds) => eds.filter((e) => e.id !== activeEdgeId))

        // cleanup the active node
        setNodes((nodes) => nodes.filter((e) => e.id !== activeNode?.id))

        // cleanup the edges that are connected to active node
        setEdges((eds) => eds.filter((edge) => edge.source !== activeNode?.id && edge.target !== activeNode?.id))

        // reset the stuff
        setActiveNodeIdFL(undefined)
        setActiveEdgeId(undefined)
    }

    useEffect(() => {
        const nodeIds = nodes.map(x => x.id)
        dispatch(Actions.KeepUnfulfilledNodeEntries, nodeIds)
    }, [nodes, nodes])

    useEffect(() => {
        if (activeNode.id && !!activeEdgeId) {
            // set the old activeEdgeId back
            setEdges((eds) =>
                eds.map((e) => {
                    if (e?.id === activeEdgeId) {
                        const color = brightenRGBString(e?.style?.stroke, 50)
                        return { ...e, style: { ...e.style, stroke: `rgb(${color[0]}, ${color[1]}, ${color[2]})` } }
                    }
                    return e
                })
            )
        }

    }, [activeNode.id])

    return {
        edges,
        nodes,
        onNodesChange,
        onEdgesChange,
        onConnect,
        setNodes,
        setEdges,
        onEdgeClick,
        onPaneClick,
        deleteActiveNodeAndEdge,
        setActiveNodeId: setActiveNodeIdFL,
        activeEdgeId,
        activeNodeId: activeNode?.id,
        activeNodeEditMode: activeNode?.editMode,
    }
}
